import * as siteActions from '../actions/site'

import {initialState as initialUserState} from './user'

/**
 * This is a special reducer that acts first before all others. In doing so, we
 * gain the ability to reset all slices of state with one action.
 *
 * @param {Object} state  The application's state before passing through to all other reducers
 * @param {Object} action The current action being reduced against
 * @returns {Object}      The updated application state
 * @see [Beyond combineReducers](https://redux.js.org/recipes/structuring-reducers/beyond-combinereducers)
 */
export default function resetReducer(state, action) {
  switch (action.type) {
    /**
     * By not passing along `state` in this case, we reset all slice reducers
     * to their initial state.
     */
    case siteActions.RESET: {
      return {
        router: state.router, // maintain history for back button continuity
        user: {
          ...initialUserState,
          isUserAndEventPending: false,
        },
      }
    }
    default:
      return state
  }
}
